export default "__VITE_PUBLIC_ASSET__1234c20d__"